import React from "react";

import classNames from "classnames";
import brand from "@utils/brand";
import { Container, Text, Button, Icon } from "@atoms";
import { Testimonial, Carousel } from "@molecules";

const { romero } = brand;

const NextButton = () => {
  return (
    <div>
      <Icon
        name={romero ? "chevron" : "arrow"}
        className={classNames("h-6 w-6", {
          "text-red": !romero,
          "-rotate-90 transform text-blue": romero,
        })}
      />
    </div>
  );
};

const PrevButton = () => {
  return (
    <div>
      <Icon
        name={romero ? "chevron" : "arrow"}
        className={classNames("h-6 w-6 transform", {
          "rotate-180 text-red": !romero,
          "rotate-90 text-blue": romero,
        })}
      />
    </div>
  );
};

const CarouselTestimonial = ({
  heading,
  copy,
  testimonials,
  link,
  inverse,
}) => {
  return (
    <div
      className={classNames("overflow-hidden px-3 py-12 sm:px-0 md:py-24", {
        "bg-brown text-white": !inverse && !romero,
        "bg-blue text-white": !inverse && romero,
      })}
    >
      <Container>
        <div className="mb-12 space-y-6 text-center">
          <Text variant="h3">{heading}</Text>
          <Text variant="body">{copy}</Text>
        </div>
        <Carousel
          nextButton={!romero ? NextButton : null}
          prevButton={!romero ? PrevButton : null}
          maxVisible={1}
          centerItems
          buttonPosition="33%"
          className="-mx-3 px-3 md:mx-0 md:px-0"
          showIndicators
        >
          {testimonials?.map(t => {
            return (
              <div className="relative w-full px-3 md:px-6">
                <Testimonial {...t} inverse={inverse} />
              </div>
            );
          })}
        </Carousel>
        {link && link.link && (
          <div className="mt-12 flex items-center justify-center">
            <Button size="sm" to={link.link}>
              {link.text}
            </Button>
          </div>
        )}
      </Container>
    </div>
  );
};

CarouselTestimonial.defaultProps = {
  inverse: false,
};

export default CarouselTestimonial;
